import React, { useState } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

const RealEstatePage: React.FC = () => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Top Contact Bar */}
      <div className="bg-blue-900 text-white py-2 text-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-between items-center">
            <div className="flex flex-wrap items-center space-x-6">
              <a href="mailto:jeffery.long@exprealty.com" className="hover:text-blue-200 cursor-pointer">
                <i className="ri-mail-line mr-1"></i>jeffery.long@exprealty.com
              </a>
              <a href="tel:928-963-2760" className="hover:text-blue-200 cursor-pointer">
                <i className="ri-phone-line mr-1"></i>(928) 963-2760
              </a>
              <span className="hidden md:inline">
                <i className="ri-map-pin-line mr-1"></i>915 Highland Pointe Dr Ste 250, Roseville, CA 95678
              </span>
            </div>
            <div className="flex items-center space-x-3">
              <a href="https://www.facebook.com/profile.php" target="_blank" rel="noopener noreferrer" className="hover:text-blue-200 cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://www.twitter.com/JeffL_eXpRealty" target="_blank" rel="noopener noreferrer" className="hover:text-blue-200 cursor-pointer">
                <i className="ri-twitter-fill"></i>
              </a>
              <a href="https://www.linkedin.com/in/jeffery-long-355a73352/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-200 cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="https://www.youtube.com/@realestatedevelopmentautho3005" target="_blank" rel="noopener noreferrer" className="hover:text-blue-200 cursor-pointer">
                <i className="ri-youtube-fill"></i>
              </a>
              <a href="https://www.instagram.com/jeffery_long_exp_realty0223443/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-200 cursor-pointer">
                <i className="ri-instagram-fill"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section with Background Image */}
      <section 
        className="relative h-screen bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://d2na8ywvtbawk2.cloudfront.net/L45cnHWvb_6JsYhIAkRdSRqaJRZkYtCm4_e1dFDwgi0/f:webp/aHR0cHM6Ly9zMy5hbWF6b25hd3MuY29tL2t1bnZlcnNpb24tcGxhdGZvcm0vd2Vic2l0ZV9iYWNrZ3JvdW5kcy9ob3VzZTMuanBn')`
        }}
      >
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white max-w-4xl mx-auto px-4">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/91f0f8e12b1f19026b27ce5c4f6b9182/cdecc81e9e70509d22f2a53538163006.png" 
                alt="Jeffery Long Real Estate Agent" 
                className="w-32 h-32 mx-auto rounded-full border-4 border-white shadow-lg object-cover"
              />
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-4">Jeffery Long</h1>
            <p className="text-xl mb-2">CA DRE# 02234432</p>
            <h2 className="text-2xl md:text-3xl mb-6">Northern / Central Valley - eXp Realty of Northern California, Inc. CA DRE#02188495</h2>
            <p className="text-xl mb-8 font-light">40 Years in Real Estate. Let my team support your journey.</p>
            
            {/* Property Search Form */}
            <div className="bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-xl max-w-4xl mx-auto">
              <form action="https://jefferylong.exprealty.com/" method="GET" target="_blank" className="grid grid-cols-1 md:grid-cols-6 gap-4">
                <div className="md:col-span-2">
                  <input 
                    type="text" 
                    name="search"
                    placeholder="City, Area, Zip, MLS# , or Addr" 
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900"
                  />
                </div>
                <div>
                  <select name="property_type" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900">
                    <option value="">Property Type</option>
                    <option value="single_family">Single Family</option>
                    <option value="condos">Condos</option>
                    <option value="commercial">Commercial</option>
                    <option value="land">Land</option>
                  </select>
                </div>
                <div>
                  <select name="beds" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900">
                    <option value="">Beds</option>
                    <option value="1">1+</option>
                    <option value="2">2+</option>
                    <option value="3">3+</option>
                    <option value="4">4+</option>
                  </select>
                </div>
                <div>
                  <select name="price_range" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900">
                    <option value="">Price Range</option>
                    <option value="0-500000">$0 - $500K</option>
                    <option value="500000-1000000">$500K - $1M</option>
                    <option value="1000000+">$1M+</option>
                  </select>
                </div>
                <div>
                  <button 
                    type="submit" 
                    className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Search
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Properties Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Featured Properties</h2>
            <p className="text-lg text-gray-600">Discover exceptional properties in Northern California</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Property 1 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative">
                <img 
                  src="https://d2na8ywvtbawk2.cloudfront.net/Qr1k7woRkg_Ftq8-kzgG29f2vIg-P36ft0Q2t6KA06M/rt:fit/w:640/f:webp/aHR0cHM6Ly9kOHdrbXVqZnUydzRsLmNsb3VkZnJvbnQubmV0L2xpc3RpbmdwaG90b3M0Ny80MjQwMjg3ODktMS5qcGc" 
                  alt="Property in Pacifica" 
                  className="w-full h-48 object-cover"
                />
                <div className="absolute top-4 left-4 bg-red-500 text-white px-2 py-1 rounded text-sm font-semibold">
                  Reduced
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Pacifica</h3>
                <p className="text-2xl font-bold text-blue-600 mb-2">$12,500,000</p>
                <p className="text-gray-600 mb-2">
                  <i className="ri-map-pin-line mr-1"></i>0 Manor Drive, Pacifica, CA 94044
                </p>
                <div className="flex justify-between text-sm text-gray-500">
                  <span>Type: Land</span>
                  <span>Lot Size: 62.45 Acres</span>
                </div>
              </div>
            </div>

            {/* Property 2 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative">
                <img 
                  src="https://d2na8ywvtbawk2.cloudfront.net/3CPFY5VxtXWjXyL9tpix83C9yNurkCtEoV5_MXzCZcI/rt:fit/w:640/f:webp/aHR0cHM6Ly9kMzZ4ZnRnYWNxbjJwLmNsb3VkZnJvbnQubmV0L2xpc3RpbmdwaG90b3M0Ny8yMjUxMDAwMDItMS5qcGc" 
                  alt="Property in El Dorado Hills" 
                  className="w-full h-48 object-cover"
                />
                <div className="absolute top-4 left-4 bg-red-500 text-white px-2 py-1 rounded text-sm font-semibold">
                  Reduced
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">El Dorado Hills</h3>
                <p className="text-2xl font-bold text-blue-600 mb-2">$1,790,000</p>
                <p className="text-gray-600 mb-2">
                  <i className="ri-map-pin-line mr-1"></i>5528 Sur Mer Drive, El Dorado Hills, CA 95762
                </p>
                <div className="flex justify-between text-sm text-gray-500">
                  <span>4 Beds + 2.5 Baths</span>
                  <span>3,362 SqFt</span>
                </div>
              </div>
            </div>

            {/* Property 3 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative">
                <img 
                  src="https://d2na8ywvtbawk2.cloudfront.net/IrE73ydHSy6IFyhK65IZhxFFVhvCiyL5ERanUJrz0GY/rt:fit/w:640/f:webp/aHR0cHM6Ly9kMzZ4ZnRnYWNxbjJwLmNsb3VkZnJvbnQubmV0L2xpc3RpbmdwaG90b3M0Ny8yMjUwODUwNzItMS5qcGc" 
                  alt="Property in Carmichael" 
                  className="w-full h-48 object-cover"
                />
                <div className="absolute top-4 left-4 bg-green-500 text-white px-2 py-1 rounded text-sm font-semibold">
                  Primary On Main
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Carmichael</h3>
                <p className="text-2xl font-bold text-blue-600 mb-2">$1,550,000</p>
                <p className="text-gray-600 mb-2">
                  <i className="ri-map-pin-line mr-1"></i>5536 Clarendon Way, Carmichael, CA 95608
                </p>
                <div className="flex justify-between text-sm text-gray-500">
                  <span>5 Beds + 3.5 Baths</span>
                  <span>4,514 SqFt</span>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-8">
            <a 
              href="https://jefferylong.exprealty.com/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              View All Properties
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="bg-gray-50 p-8 rounded-lg">
              <img 
                src="https://public.readdy.ai/ai/img_res/4e421ba3dd24885edb4161d39065dd0d.jpg" 
                alt="Thinking of Selling" 
                className="w-full h-64 object-cover rounded-lg mb-6"
              />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Thinking of Selling?</h3>
              <p className="text-gray-600 mb-6">Get your FREE Home Valuation complete with local comparables instantly.</p>
              <a 
                href="https://jefferylong.exprealty.com/sell.php" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                Get Your Home Value
              </a>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg">
              <img 
                src="https://readdy.ai/api/search-image?query=Happy%20family%20looking%20at%20beautiful%20house%20exterior%2C%20modern%20home%20with%20landscaping%2C%20real%20estate%20purchase%2C%20dream%20home%2C%20sunny%20day%2C%20professional%20photography&width=600&height=400&seq=realestate003&orientation=landscape" 
                alt="Looking to Purchase" 
                className="w-full h-64 object-cover rounded-lg mb-6"
              />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Looking to Purchase?</h3>
              <p className="text-gray-600 mb-6">Search thousands of current listings directly from our local MLS.</p>
              <a 
                href="https://jefferylong.exprealty.com/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                Start Your Search
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Luxury Listings Section */}
      <section className="py-16 bg-gray-900 text-white relative">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Luxury%20modern%20house%20exterior%20with%20pool%2C%20upscale%20architecture%2C%20evening%20lighting%2C%20high-end%20real%20estate%2C%20elegant%20design%2C%20professional%20photography&width=1200&height=600&seq=realestate004&orientation=landscape')`
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-4">Discover Luxury Listings</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Get an insider look at these hot luxury listings within the MLS. Ask your agent about current showings!
          </p>
          <a 
            href="https://jefferylong.exprealty.com/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer inline-block"
          >
            Learn More
          </a>
        </div>
      </section>

      {/* About Agent Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">About Jeffery Long</h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://static.readdy.ai/image/91f0f8e12b1f19026b27ce5c4f6b9182/cdecc81e9e70509d22f2a53538163006.png" 
                alt="Jeffery Long" 
                className="w-full max-w-md mx-auto rounded-lg shadow-lg"
              />
            </div>
            <div>
              <p className="text-lg text-gray-700 mb-6">
                I'm a seasoned Commercial and Residential Real Estate Agent and Published Author with over 40 years of experience, beginning my career in land development in June 1980. I have a proven track record in building, repairing, selling, appraising, managing projects, and purchasing both commercial and residential properties, as well as various businesses.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-blue-900 mb-2">Experience</h3>
                  <p className="text-blue-800">40+ Years in Real Estate</p>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-blue-900 mb-2">License</h3>
                  <p className="text-blue-800">CA DRE# 02234432</p>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-blue-900 mb-2">Specialties</h3>
                  <p className="text-blue-800">Commercial & Residential</p>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-blue-900 mb-2">Phone</h3>
                  <p className="text-blue-800">928 963 2760</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Meet the Team</h2>
            <p className="text-lg text-gray-600">Northern / Central Valley - eXp Realty of Northern California, Inc. CA DRE#02188495</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {/* Team Member 1 */}
            <div className="text-center">
              <div className="w-24 h-24 bg-gray-300 rounded-full mx-auto mb-3 overflow-hidden">
                <img 
                  src="https://dtzulyujzhqiu.cloudfront.net/expcorporate377/profiles/1710530659.jpg" 
                  alt="Selena Aguilar" 
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-semibold text-gray-900">Selena Aguilar</h4>
              <p className="text-sm text-gray-600">CA DRE# 02201461</p>
            </div>

            {/* Team Member 2 */}
            <div className="text-center">
              <div className="w-24 h-24 bg-gray-300 rounded-full mx-auto mb-3 overflow-hidden">
                <img 
                  src="https://dtzulyujzhqiu.cloudfront.net//profiles/1677229877.jpg" 
                  alt="Lucille Alicante" 
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-semibold text-gray-900">Lucille Alicante</h4>
              <p className="text-sm text-gray-600">CA DRE# 02199982</p>
            </div>

            {/* Team Member 3 */}
            <div className="text-center">
              <div className="w-24 h-24 bg-gray-300 rounded-full mx-auto mb-3 overflow-hidden">
                <img 
                  src="https://dtzulyujzhqiu.cloudfront.net//profiles/1689383401.jpg" 
                  alt="Samuel Otniel Ana" 
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-semibold text-gray-900">Samuel Otniel Ana</h4>
              <p className="text-sm text-gray-600">CA DRE# 02126613</p>
            </div>

            {/* Team Member 4 */}
            <div className="text-center">
              <div className="w-24 h-24 bg-gray-300 rounded-full mx-auto mb-3 overflow-hidden">
                <img 
                  src="https://dtzulyujzhqiu.cloudfront.net/expcorporate377/profiles/1738965187.jpg" 
                  alt="Angel ArauzaOchoa" 
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-semibold text-gray-900">Angel ArauzaOchoa</h4>
              <p className="text-sm text-gray-600">CA DRE# 02243881</p>
            </div>

            {/* Team Member 5 */}
            <div className="text-center">
              <div className="w-24 h-24 bg-gray-300 rounded-full mx-auto mb-3 overflow-hidden">
                <img 
                  src="https://dtzulyujzhqiu.cloudfront.net/expcorporate377/profiles/1716223791.jpg" 
                  alt="Candi Arnold" 
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-semibold text-gray-900">Candi Arnold</h4>
              <p className="text-sm text-gray-600">CA DRE# 02231157</p>
            </div>

            {/* Team Member 6 */}
            <div className="text-center">
              <div className="w-24 h-24 bg-gray-300 rounded-full mx-auto mb-3 overflow-hidden">
                <img 
                  src="https://dtzulyujzhqiu.cloudfront.net/expcorporate377/profiles/1712932440.jpg" 
                  alt="Karen Arnold" 
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-semibold text-gray-900">Karen Arnold</h4>
              <p className="text-sm text-gray-600">CA DRE# 02030608</p>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Latest Blog Posts</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Blog Post 1 */}
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Real%20estate%20agent%20providing%20professional%20services%20to%20clients%2C%20home%20selling%20consultation%2C%20modern%20office%20setting%2C%20business%20meeting%2C%20professional%20photography&width=400&height=250&seq=realestate005&orientation=landscape" 
                alt="Top Ten Services" 
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Top Ten Services a Realtor Can Provide to Sell a Customer's House</h3>
                <p className="text-gray-600 mb-4">Top Ten Services a Realtor Can Provide to Sell a Customer's House. Pricing the Home Accurately. A realtor's top job is setting the right price. In Cameron Park, where home values can vary...</p>
                <div className="text-sm text-gray-500 mb-4">
                  <span>Posted by Jeffery Long</span> • <span>May 25 2025</span>
                </div>
                <a 
                  href="https://jefferylong.exprealty.com/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-blue-600 hover:text-blue-700 font-semibold cursor-pointer"
                >
                  Read More <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
            </div>

            {/* Blog Post 2 */}
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Homeowner%20insurance%20concept%2C%20house%20protection%2C%20insurance%20documents%2C%20family%20home%20security%2C%20professional%20consultation%2C%20modern%20home%20exterior&width=400&height=250&seq=realestate006&orientation=landscape" 
                alt="Homeowner Insurance" 
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Buying Homeowner Insurance in Cameron Park</h3>
                <p className="text-gray-600 mb-4">Navigating Homeowner Insurance in Cameron Park: Your Ultimate Guide. Buying homeowner insurance in Cameron Park, California, isn't just about checking a box—it's about protecting...</p>
                <div className="text-sm text-gray-500 mb-4">
                  <span>Posted by Jeffery Long</span> • <span>May 23 2025</span>
                </div>
                <a 
                  href="https://jefferylong.exprealty.com/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-blue-600 hover:text-blue-700 font-semibold cursor-pointer"
                >
                  Read More <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
            </div>

            {/* Blog Post 3 */}
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=ADU%20accessory%20dwelling%20unit%20construction%2C%20modern%20backyard%20cottage%2C%20property%20development%2C%20Sacramento%20real%20estate%2C%20additional%20housing%20unit%2C%20architectural%20design&width=400&height=250&seq=realestate007&orientation=landscape" 
                alt="ADU Property" 
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">How to Add an ADU to Your Property in Sacramento</h3>
                <p className="text-gray-600 mb-4">How to Add an ADU to Your Property in Sacramento. Imagine turning your Sacramento backyard into a cozy guesthouse for your in-laws, a rental unit that pays for itself, or a private home office...</p>
                <div className="text-sm text-gray-500 mb-4">
                  <span>Posted by Jeffery Long</span> • <span>April 24 2025</span>
                </div>
                <a 
                  href="https://jefferylong.exprealty.com/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-blue-600 hover:text-blue-700 font-semibold cursor-pointer"
                >
                  Read More <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Areas Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Areas We Cover</h2>
            <p className="text-lg text-gray-600">Serving Northern and Central California with expertise and dedication</p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Service Areas</h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                <div className="space-y-2">
                  <a href="https://jefferylong.exprealty.com/" target="_blank" rel="noopener noreferrer" className="block text-blue-600 hover:text-blue-700 cursor-pointer">
                    <i className="ri-map-pin-line mr-1"></i>Sacramento
                  </a>
                  <a href="https://jefferylong.exprealty.com/" target="_blank" rel="noopener noreferrer" className="block text-blue-600 hover:text-blue-700 cursor-pointer">
                    <i className="ri-map-pin-line mr-1"></i>Auburn
                  </a>
                  <a href="https://jefferylong.exprealty.com/" target="_blank" rel="noopener noreferrer" className="block text-blue-600 hover:text-blue-700 cursor-pointer">
                    <i className="ri-map-pin-line mr-1"></i>Roseville
                  </a>
                  <a href="https://jefferylong.exprealty.com/" target="_blank" rel="noopener noreferrer" className="block text-blue-600 hover:text-blue-700 cursor-pointer">
                    <i className="ri-map-pin-line mr-1"></i>Folsom
                  </a>
                </div>
                <div className="space-y-2">
                  <a href="https://jefferylong.exprealty.com/" target="_blank" rel="noopener noreferrer" className="block text-blue-600 hover:text-blue-700 cursor-pointer">
                    <i className="ri-map-pin-line mr-1"></i>El Dorado Hills
                  </a>
                  <a href="https://jefferylong.exprealty.com/" target="_blank" rel="noopener noreferrer" className="block text-blue-600 hover:text-blue-700 cursor-pointer">
                    <i className="ri-map-pin-line mr-1"></i>Granite Bay
                  </a>
                  <a href="https://jefferylong.exprealty.com/" target="_blank" rel="noopener noreferrer" className="block text-blue-600 hover:text-blue-700 cursor-pointer">
                    <i className="ri-map-pin-line mr-1"></i>Cameron Park
                  </a>
                  <a href="https://jefferylong.exprealty.com/" target="_blank" rel="noopener noreferrer" className="block text-blue-600 hover:text-blue-700 cursor-pointer">
                    <i className="ri-map-pin-line mr-1"></i>Carmichael
                  </a>
                </div>
                <div className="space-y-2">
                  <a href="https://jefferylong.exprealty.com/" target="_blank" rel="noopener noreferrer" className="block text-blue-600 hover:text-blue-700 cursor-pointer">
                    <i className="ri-map-pin-line mr-1"></i>Citrus Heights
                  </a>
                  <a href="https://jefferylong.exprealty.com/" target="_blank" rel="noopener noreferrer" className="block text-blue-600 hover:text-blue-700 cursor-pointer">
                    <i className="ri-map-pin-line mr-1"></i>Fair Oaks
                  </a>
                  <a href="https://jefferylong.exprealty.com/" target="_blank" rel="noopener noreferrer" className="block text-blue-600 hover:text-blue-700 cursor-pointer">
                    <i className="ri-map-pin-line mr-1"></i>Orangevale
                  </a>
                  <a href="https://jefferylong.exprealty.com/" target="_blank" rel="noopener noreferrer" className="block text-blue-600 hover:text-blue-700 cursor-pointer">
                    <i className="ri-map-pin-line mr-1"></i>Elk Grove
                  </a>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Service Area Map</h3>
              <div className="aspect-video rounded-lg overflow-hidden shadow-lg">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d804686.2922526915!2d-122.3301083!3d38.5816223!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x809ac672b28397f9%3A0x921f6aaa74197fdb!2sSacramento%2C%20CA!5e0!3m2!1sen!2sus!4v1697000000000!5m2!1sen!2sus"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Service Areas Map"
                ></iframe>
              </div>
              <div className="mt-4 text-sm text-gray-600">
                <p><strong>Primary Service Areas:</strong> Sacramento, Auburn, Roseville, Folsom, El Dorado Hills, Granite Bay, and surrounding Northern California communities.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-16 bg-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold mb-6">Ready to Start Your Real Estate Journey?</h2>
              <p className="text-xl mb-8">
                With 40 years of experience in Northern California real estate, I'm here to help you achieve your property goals.
              </p>
              <div className="space-y-4">
                <div className="flex items-center">
                  <i className="ri-phone-line text-2xl mr-4"></i>
                  <div>
                    <p className="font-semibold">Phone</p>
                    <a href="tel:928-963-2760" className="text-blue-200 hover:text-white cursor-pointer">928 963 2760</a>
                  </div>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line text-2xl mr-4"></i>
                  <div>
                    <p className="font-semibold">Email</p>
                    <a href="mailto:jeffery.long@exprealty.com" className="text-blue-200 hover:text-white cursor-pointer">jeffery.long@exprealty.com</a>
                  </div>
                </div>
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-2xl mr-4"></i>
                  <div>
                    <p className="font-semibold">Office</p>
                    <p className="text-blue-200">915 Highland Pointe Dr Ste 250<br />Roseville, CA 95678</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <i className="ri-award-line text-2xl mr-4"></i>
                  <div>
                    <p className="font-semibold">License</p>
                    <p className="text-blue-200">CA DRE# 02234432</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white/10 p-8 rounded-lg">
              <h3 className="text-2xl font-bold mb-6">Contact Us</h3>
              <form 
                action="https://readdy.ai/api/form/d46q4c534biqimnfo7t0" 
                method="POST" 
                data-readdy-form
                className="space-y-4"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="firstName" className="block text-sm font-medium mb-2">First Name</label>
                    <input 
                      type="text" 
                      id="firstName" 
                      name="firstName" 
                      required 
                      className="w-full px-4 py-3 rounded-lg bg-white/20 border border-white/30 text-white placeholder-white/70 focus:ring-2 focus:ring-white focus:border-transparent"
                      placeholder="Your first name"
                    />
                  </div>
                  <div>
                    <label htmlFor="lastName" className="block text-sm font-medium mb-2">Last Name</label>
                    <input 
                      type="text" 
                      id="lastName" 
                      name="lastName" 
                      required 
                      className="w-full px-4 py-3 rounded-lg bg-white/20 border border-white/30 text-white placeholder-white/70 focus:ring-2 focus:ring-white focus:border-transparent"
                      placeholder="Your last name"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium mb-2">Email</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    required 
                    className="w-full px-4 py-3 rounded-lg bg-white/20 border border-white/30 text-white placeholder-white/70 focus:ring-2 focus:ring-white focus:border-transparent"
                    placeholder="your.email@example.com"
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium mb-2">Phone</label>
                  <input 
                    type="tel" 
                    id="phone" 
                    name="phone" 
                    className="w-full px-4 py-3 rounded-lg bg-white/20 border border-white/30 text-white placeholder-white/70 focus:ring-2 focus:ring-white focus:border-transparent"
                    placeholder="(928) 963-2760"
                  />
                </div>
                <div>
                  <label htmlFor="propertyType" className="block text-sm font-medium mb-2">Property Interest</label>
                  <select 
                    id="propertyType" 
                    name="propertyType" 
                    className="w-full px-4 py-3 rounded-lg bg-white/20 border border-white/30 text-white focus:ring-2 focus:ring-white focus:border-transparent"
                  >
                    <option value="">Select your interest</option>
                    <option value="buying">Buying a Home</option>
                    <option value="selling">Selling a Home</option>
                    <option value="investing">Real Estate Investment</option>
                    <option value="commercial">Commercial Property</option>
                    <option value="consultation">General Consultation</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium mb-2">Message</label>
                  <textarea 
                    id="message" 
                    name="message" 
                    rows={4} 
                    maxLength={500}
                    className="w-full px-4 py-3 rounded-lg bg-white/20 border border-white/30 text-white placeholder-white/70 focus:ring-2 focus:ring-white focus:border-transparent resize-none"
                    placeholder="Tell us about your real estate needs..."
                  ></textarea>
                  <p className="text-xs text-white/70 mt-1">Maximum 500 characters</p>
                </div>
                <button 
                  type="submit" 
                  className="w-full bg-white text-blue-900 py-3 px-6 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RealEstatePage;
